export default "__VITE_ASSET__8PjL_2pO__"